import { useTranslation } from "react-i18next";
import MobileNav from "./MobileNav";
import Navbar from "./Navbar";
import { Link } from "react-router-dom";
import i18n from "../i18n";
import { useState } from "react";  
import { useEffect } from "react";
import logoImg from '../assets/logo.png';


 

const Header = () => {
  const { i18n } = useTranslation();
    const { t } = useTranslation();
/*const supportedLangs = [{ code: 'en'   , name: 'ENGLISH-USA' },
					    { code: 'es-MX', name: 'ESPAÑOL-México' }];*/
const supportedLangs = [
  { code: 'en',    name: 'ENGLISH-USA' }, //En-USA ENGLISH
  { code: 'ar',    name: 'Ar-العربية' },
  { code: 'zh',    name: 'Ch-中文' },
  { code: 'de',    name: 'Ge-DEUTSCH' },
  { code: 'hi',    name: 'Hi-हिन्दी' },
  { code: 'id',    name: "In-BAHASA" },
  { code: 'it',    name: "It-ITALIANO" },
  { code: 'ja',    name: 'Ja-日本語' },
  { code: 'ko',    name: 'Ko-한국어' },
  { code: 'ms',    name: "MS-BAHASA" },
  { code: 'nl',    name: 'Ne-NEDERLANDS' },
  { code: 'pt-BR', name: 'Po-PORTUGUÊS' },
  { code: 'ru',    name: 'Ru-РУССКИЙ' },
  { code: 'es-MX', name: 'ESPAÑOL-México' },//name: 'Sp-ESPAÑOL' 
  { code: 'tr',    name: 'Tu-TÜRKÇE' },
  { code: 'vi',    name: 'Vi-TIẾNG VIỆT' }
];


  const [showModal, setShowModal] = useState(false);
 
  
  useEffect(() => {
  const handleKeyDown = (event) => {
    if (showModal) {
      setShowModal(false);
    }
  };

  window.addEventListener("keydown", handleKeyDown);

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [showModal]);

useEffect(() => {
  const applyDirection = (language) => {
    const lang = String(language || 'en').toLowerCase();

    const rtl =
      lang === 'ar' ||
      lang.startsWith('ar-') ||
      lang === 'fa' ||
      lang.startsWith('fa-');

    document.documentElement.dir = rtl ? 'rtl' : 'ltr';
    document.documentElement.lang = lang;
  };

  applyDirection(i18n.resolvedLanguage || i18n.language);

  i18n.on('languageChanged', applyDirection);

  return () => {
    i18n.off('languageChanged', applyDirection);
  };
}, [i18n]);


const changeLanguage = (langCode) => {
  i18n.changeLanguage(langCode);
};
  
 
	const closeModal = () => {
	  setShowModal(false);
	};
  
  return <>
  
    <header>
      <div className="nav-area">
<Link
  to="/"
  className="home-logo-link"
  aria-label={t("Home")}
  title={t("Home")}
>
  <img
    src={logoImg}
    alt={t("Stark RWAE Exchange Home")}
    className="logo"
    style={{
      width: "40px",
      height: "40px",
      cursor: "pointer"
    }}
  />
</Link>

<button
  type="button"
  className="platform-info-button"
  onClick={() => setShowModal(true)}
  aria-label={t("About Stark RWAE Exchange")}
  title={t("About Stark RWAE Exchange")}
>
  ⓘ
</button>
		<select 
            value={i18n.language} 
            onChange={(e) => changeLanguage(e.target.value)}
            style={{
              padding: '5px 10px',
              borderRadius: '4px',
              border: '1px solid #ccc',
              backgroundColor: '#fff',
              cursor: 'pointer'
            }}
          >
            {supportedLangs.map((lang) => (
              <option key={lang.code} value={lang.code}>
                {lang.name}
              </option>
            ))}
          </select>
        {/* for large screens */}
        <Navbar />

        {/* for small screens */}
        <MobileNav />
      </div>
    </header>
	{showModal && (
  <div
    style={{
      position: 'fixed',
      top: 0, left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}
    onClick={closeModal}
  >
    <div style={{ position: 'relative', textAlign: 'center', maxWidth: '90%', maxHeight: '90%' }}>
      <p style={{ color: 'white', marginTop: '10px', fontSize: '18px' }}>
		  {t(`Stark RWA Exchange`)}
      </p>
      <img
        src={logoImg}
        alt="Enlarged Logo"
        style={{ maxWidth: '100%', maxHeight: '100%', borderRadius: '10px' }}
      />
      <p style={{ color: 'white', marginTop: '10px', fontSize: '18px' }}>
		{t(`A regulated real-asset tokenization platform for land, rental properties, development projects, and auction-based real estate opportunities.`)}
      </p>
    </div>
  </div>
)}
  </>
};

export default Header;
